interface ExceptionLanguageMap extends Record<string, string> {}

export const EXCEPTION_TIME_FORMAT_LANG_MAP: ExceptionLanguageMap = {
  cn: 'zh',
};

export const EXCEPTION_DATE_FORMAT_LANG_MAP: ExceptionLanguageMap = {
  sr: 'sr-Latn-RS',
  cn: 'zh',
};

export interface DateFormatterFactoryExeptions {
  time: ExceptionLanguageMap;
  date: ExceptionLanguageMap;
}

type DateFormatterDateType = Date | number | string;

export class DateFormatterFactory {
  constructor(
    private exeptions: DateFormatterFactoryExeptions = {
      time: EXCEPTION_TIME_FORMAT_LANG_MAP,
      date: EXCEPTION_DATE_FORMAT_LANG_MAP,
    }
  ) {}

  private resolveLanguage(language?: string, ...maps: ExceptionLanguageMap[]): string | undefined {
    if (!language) return undefined;

    const lowerCaseLanguage = language.toLocaleLowerCase();

    for (const map of maps) {
      if (map[lowerCaseLanguage]) {
        return map[lowerCaseLanguage];
      }
    }

    return lowerCaseLanguage;
  }

  private getDate(date: DateFormatterDateType): Date {
    return date instanceof Date ? date : new Date(date);
  }

  toLocaleDateString(date: DateFormatterDateType, language?: string, options?: Intl.DateTimeFormatOptions): string {
    return this.getDate(date).toLocaleDateString(this.resolveLanguage(language, this.exeptions.date), options);
  }

  toLocaleTimeString(date: DateFormatterDateType, language?: string, options?: Intl.DateTimeFormatOptions): string {
    return this.getDate(date).toLocaleTimeString(this.resolveLanguage(language, this.exeptions.time), options);
  }

  toLocaleString(date: DateFormatterDateType, language?: string, options?: Intl.DateTimeFormatOptions): string {
    return this.getDate(date).toLocaleString(
      this.resolveLanguage(language, this.exeptions.date, this.exeptions.time),
      options
    );
  }
}

export const DateFormatter = new DateFormatterFactory();
